<div [formGroup]="form">
  <mat-radio-group class="tiledRadioGroup" formControlName="profile_type" required>
    <div class="profile-selector-first-headline">Du bist mit diesem Profil angemeldet</div>

    <div class="profile-selector-container">
      <mat-radio-button [value]="ProfileTypeIdentifier.private" *ngIf="showPrivate()" class="profile">
        <user-image [profile]="UserService.user"></user-image>
        <div>Privates Profil</div>
      </mat-radio-button>
    </div>

    <div
      class="profile-selector-second-headline"
      *ngIf="!UserService.isPremiumCompanyProfile() && UserService.getCompanyProfile()"
    >
      Weitere Profile
    </div>

    <div class="profile-selector-container">
      <mat-radio-button
        [value]="ProfileTypeIdentifier.business"
        *ngIf="UserService.getCompanyProfile()"
        class="profile"
      >
        <user-image [isCompanyProfileFallbackImage]="true" [profile]="UserService.getCompanyProfile()"></user-image>
        <div>Unternehmensprofil</div>
      </mat-radio-button>
    </div>
  </mat-radio-group>
</div>
